export class UserCompany {
  UserId?: number;
  CompanyId: number;
}
